import { Controller } from '@hotwired/stimulus';

// ダッシュボードの年間合計行の開閉 (#3048)。
// 集計は納付書を書く時期にしか使わないため既定は閉じた状態。
//
// 開閉状態は localStorage に持つ。年タブは Turbo Frame (#payments) で表ごと
// 差し替わるため、DOM だけに状態を持つと年を切り替えるたびに閉じてしまう。
// localStorage は private window 等で例外を投げうるので読み書きとも握りつぶし、
// 失敗時は既定(閉じる)で動かす。
export default class extends Controller {
  static targets = ['row', 'button', 'label', 'icon'];
  static values = {
    storageKey: { type: String, default: 'dashboard-yearly-totals-open' },
    openLabel: { type: String, default: '集計を隠す' },
    closedLabel: { type: String, default: '集計を表示' },
  };

  connect() {
    this.setOpen(this.storedOpen());
    // 接続済みの印。system spec が「まだ未接続のボタンを押す」のを避けるために使う。
    this.element.dataset.totalsToggleReady = 'true';
  }

  toggle() {
    const next = !this.open;
    this.setOpen(next);
    this.store(next);
  }

  setOpen(value) {
    this.open = value;
    this.rowTargets.forEach((row) => { row.hidden = !value; });

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', String(value));
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = value ? this.openLabelValue : this.closedLabelValue;
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('dashboard-totals-toggle__ico--open', value);
    }
  }

  storedOpen() {
    try {
      return window.localStorage.getItem(this.storageKeyValue) === '1';
    } catch {
      return false;
    }
  }

  store(value) {
    try {
      window.localStorage.setItem(this.storageKeyValue, value ? '1' : '0');
    } catch {
      // 保存できなくても開閉そのものは動かす。
    }
  }
}
